import API from './index';
import '../helpers';


function submitAssessmentRequest(answers) {
	const options = {
		method: 'POST',
		headers: {
			'auth-token': `${answers.token}`
		}
	};
	const answer = {
		answers: answers.data,
		phase: answers.data[0].phase,
		type: answers.data[0].label,
		session_start: answers.data[0].session_start,
		session_end: new Date().toLocaleString()
	};
	// const answer = answers.data;
	return API.post('/questions', answer, options)
		.then((result) => {
			return result;
		})
		.catch((error) => {
			throw error.response;
		});
}


function getAssessment(params) {
	// const options = {
	// 	method: 'GET',
	// 	headers: {
	// 		'auth-token': `${params.data.authToken}`
	// 	}
	// };
	// return API.get('/questions/by/Assessment', options)
	// 	.then((result) => {
	// 		return result;
	// 	})
	// 	.catch((error) => {
	// 		throw error.response
	// 	});
	//
	//
	const options = {
		method: 'GET',
		headers: {
			'auth-token': `${params.data.authToken}`
		}
	};
	return API.get('/questions/by/Assessment', options)
		.then((result) => {
			return result;
		})
		.catch((error) => {
			throw error.response;
		});
}


export const assessmentService = {
	getAssessment,
	submitAssessmentRequest
};
